import { render } from "./BigPopModel.vue?vue&type=template&id=f52f0816&scoped=true"
import script from "./BigPopModel.vue?vue&type=script&lang=js"
export * from "./BigPopModel.vue?vue&type=script&lang=js"

import "./BigPopModel.vue?vue&type=style&index=0&id=f52f0816&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f52f0816"]])

export default __exports__